import '@patternfly/pfe-core/ssr-shims.js';
import { standard, social, ui, microns } from '@rhds/icons';
globalThis.RH_ICONS = new Map(Object.entries({ standard, social, ui, microns }));
//# sourceMappingURL=ssr.js.map